import { actions, connect } from "../store/";
import { IAdsService } from "../types/IAdsService";
import { IConfig } from "../types/IConfig";

import DisplayFallback from "./DisplayFallback";
import { H5Fallback } from "./H5Fallback";

export interface IFallbackProps {
  service: IAdsService;
  config: IConfig;
  finish: () => void;
}

export const Fallback = ({ service, config, finish }: IFallbackProps) => {
  if (service.useH5) {
    return <H5Fallback onFinish={finish} position={ config.type === 'rewarded' ? 'rewarded' : 'interstitial' }/>;
  } else {
    return <DisplayFallback />;
  }
}

export default connect(['service', 'config'], actions)(Fallback);
